import { Directive, ElementRef, Input, Renderer2 } from "@angular/core";
import { AbstractControl } from "@angular/forms";
import { Subscription } from "rxjs";

@Directive({
  selector: "[dateMask]"
})
export class DateDirective {
  private _control!: AbstractControl;
  private _preValue: string = "";
  private _id: string = "";
  @Input()
  set control(control: AbstractControl) {
    this._control = control;
  }
  @Input()
  set preValue(value: string) {
    this._preValue = value;
  }
  @Input()
  set id(value: string) {
    this._id = value;
  }

  private sub!: Subscription;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit() {
    this.validate();
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  filterNonNumeric(input: string) {
    return input.replace(/\D/g, "");
  }
  public getStart() {
    return this.renderer.selectRootElement("#" + this._id).selectionStart;
  }
  public getEnd() {
    return this.renderer.selectRootElement("#" + this._id).selectionEnd;
  }
  public isBackspace(next: string) {
    return this._preValue.length > next.length;
  }
  public setRange(start: number, end: number) {
    this.renderer
      .selectRootElement("#" + this._id)
      .setSelectionRange(start, end);
  }

  validate() {
    this.sub = this._control.valueChanges.subscribe(data => {
      var numbers = this.filterNonNumeric(data);
      if (numbers.length == 0) {
        this._control.setValue("", { emitEvent: false });
        return;
      } else if (!["0", "1"].includes(numbers[0])) {
        numbers = "0" + numbers;
      }
      var result = "";
      var month = numbers.slice(0, 2);
      var day = numbers.slice(3, 5);
      var year = numbers.slice(6, 10);
      result = [month, day, year].join("/");
      this._control.setValue(result.trim(), { emitEvent: false });
    });
  }
}
